/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StudentMetaFormativeActions from './StudentMetaFormativeActions';

/**
 * The StudentMetaCoursingEnrolls model module.
 * @module model/StudentMetaCoursingEnrolls
 * @version 1.0.0
 */
class StudentMetaCoursingEnrolls {
    /**
     * Constructs a new <code>StudentMetaCoursingEnrolls</code>.
     * @alias module:model/StudentMetaCoursingEnrolls
     */
    constructor() { 
        
        StudentMetaCoursingEnrolls.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentMetaCoursingEnrolls</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentMetaCoursingEnrolls} obj Optional instance to populate.
     * @return {module:model/StudentMetaCoursingEnrolls} The populated <code>StudentMetaCoursingEnrolls</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentMetaCoursingEnrolls();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('formative_zone')) {
                obj['formative_zone'] = ApiClient.convertToType(data['formative_zone'], 'String');
            }
            if (data.hasOwnProperty('formative_zone_code')) {
                obj['formative_zone_code'] = ApiClient.convertToType(data['formative_zone_code'], 'String');
            }
            if (data.hasOwnProperty('academic_section_id')) {
                obj['academic_section_id'] = ApiClient.convertToType(data['academic_section_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_section_title')) {
                obj['academic_section_title'] = ApiClient.convertToType(data['academic_section_title'], 'String');
            }
            if (data.hasOwnProperty('formative_action')) {
                obj['formative_action'] = StudentMetaFormativeActions.constructFromObject(data['formative_action']);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
StudentMetaCoursingEnrolls.prototype['id'] = undefined;

/**
 * @member {Number} status
 */
StudentMetaCoursingEnrolls.prototype['status'] = undefined;

/**
 * @member {Number} academic_program_id
 */
StudentMetaCoursingEnrolls.prototype['academic_program_id'] = undefined;

/**
 * @member {String} formative_zone
 */
StudentMetaCoursingEnrolls.prototype['formative_zone'] = undefined;

/**
 * @member {String} formative_zone_code
 */
StudentMetaCoursingEnrolls.prototype['formative_zone_code'] = undefined;

/**
 * @member {Number} academic_section_id
 */
StudentMetaCoursingEnrolls.prototype['academic_section_id'] = undefined;

/**
 * @member {String} academic_section_title
 */
StudentMetaCoursingEnrolls.prototype['academic_section_title'] = undefined;

/**
 * @member {module:model/StudentMetaFormativeActions} formative_action
 */
StudentMetaCoursingEnrolls.prototype['formative_action'] = undefined;






export default StudentMetaCoursingEnrolls;

